import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  readonly url = environment.apiUrl + '/user/';

  uid: number;


  constructor(private router: Router, private http: HttpClient) {
    if (localStorage.getItem('uid')) {
      this.uid = parseInt(localStorage.getItem('uid'), 10);
    }
  }

  login(username: string, passwd: string): Promise<void | boolean> {
    return new Promise((resolve, reject) => {
      this.http.post(this.url + 'authorize', { Username: username, Password: passwd}).subscribe(
        (data: any) => {
          if (data) {
            localStorage.setItem('uid', data.id);
            this.uid = data.id;
            resolve(true);
          } else {
            resolve(false);
          }
        },
        (error) => {
          console.log(error);
          resolve(false);
        }
      );
    });
  }

  logout(): void {
    localStorage.removeItem('uid');
    this.uid = null;
    this.router.navigate(['/login']).catch(err => console.log(err));
  }

  isLoggedIn(): boolean {
    return this.uid != null;
  }
}
